<template>
  <div>
    <div
      class="avatar"
      :class="{ 'avatar--drag-over': isDragging }"
      @dragover.prevent="handleDragOver"
      @dragleave.prevent="handleDragLeave"
      @drop.prevent="handleDrop">
      <img
        v-if="props.modelValue"
        class="avatar__image"
        :src="props.modelValue"
        alt="" />
      <img
        v-else
        class="avatar__image"
        src="@/assets/img/profile/profile_initial_photo.png"
        alt="" />

      <template v-if="!readOnly">
        <input
          :id="`AvatarInput${avatarId}`"
          ref="avatarInput"
          type="file"
          accept="image/png, image/jpg"
          @change="updateProfilePhoto($event)" />
        <transition-fade>
          <label v-if="editMode" class="avatar__edit" :for="`AvatarInput${avatarId}`">
            <EditIcon class="h-full" />
          </label>
        </transition-fade>
      </template>
    </div>
  </div>
</template>
<script setup lang="ts">
import EditIcon from '~/assets/img/icons/edit_button.svg?skipsvgo'
import { updatePhoto } from '~/utils'
import { useModal } from 'vue-final-modal'
import CropImageModal from '~/components/Modal/CropImageModal.vue'
import { uuid } from 'vue-uuid';
const { $toast } = useNuxtApp()

const emits = defineEmits<{
  (e: 'update:modelValue', modelValue: string): void
  (e: 'closed'): void
}>()

const props = defineProps({
  modelValue: {
    type: String,
    default: '',
  },
  type: {
    type: String,
    default: 'offers',
  },
  readOnly: {
    type: Boolean,
    default: false,
  },
  editMode: {
    type: Boolean,
    default: false,
  },
    updateAvatarEndpoint: {
        type: String,
        default: null
    }
})

const avatarId = uuid.v1();
const avatarInput = ref(null)
const isDragging = ref(false)

function updateProfilePhoto(event: Event | DragEvent) {
  updatePhoto(event)
    .then((result: string) => {
      const { open } = useModal({
        component: CropImageModal,
        attrs: {
          image: result,
          endpoint: props.updateAvatarEndpoint
        },
      })

      open()
      /* console.log('loaded')
    emits('update:modelValue', result)*/
    })
    .catch(error => {
      $toast.error(error)
    })
}

const handleDrop = (event: Event | DragEvent) => {
  if (!props.editMode) return

  updateProfilePhoto(event)
  isDragging.value = false
}

const handleDragOver = () => {
  if (!props.editMode) return
  isDragging.value = true
}

const handleDragLeave = () => {
  if (!props.editMode) return
  isDragging.value = false
}
</script>
<style lang="scss">
@use '@/assets/scss/abstracts/mixins';
.avatar {
  width: clamp(auto, 100%, 300px);
  aspect-ratio: 1 / 1;
  transition: all 0.2s ease;
  position: relative;
  &__image {
    @include mixins.maskAvatar();
    &.no-mask {
      mask-image: none;
    }
  }

  &__edit {
    --bg-color: #fff;
    --fill-color: var(--bg-color);
    --padding: 25px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    background-color: var(--bg-color);
    border-radius: 50%;
    cursor: pointer;
    transition: background-color 0.15s ease;
    padding: var(--padding);
    &:hover {
      --bg-color: #e1e0e0;
    }
  }
  &--drag-over {
    transform: scale(1.1);
    opacity: 0.5;
  }
}
@media (max-width: 1024px) {
  .avatar {
    &__image {
      max-width: 150px;
      max-height: 150px;
    }
  }
}
</style>
